// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2485) return "static/chunks/2485-25aab6330b1b737c.js";
	if (chunkId === 9295) return "static/chunks/9295-b47e116cc6e98562.js";
	if (chunkId === 239) return "static/chunks/239-f98c220d46cbb6d6.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7646 ? "a3319169" : chunkId) + "." + {"2777":"bf26ef2c4f5495b8","7497":"b54f8103fd07224d","7646":"246da933691e2834"}[chunkId] + ".js";
};